import React from 'react';
import { aibTheme } from '~/uikit/Theme/Theme';
import { createSvgIcon } from './utils/createSvgIcon';

const colors = aibTheme.palette;

export const IconAlert = createSvgIcon(
  'alert',
  <g>
    <path
      d="M12.4705 22.2117C17.9933 22.2117 22.4705 17.7345 22.4705 12.2117C22.4705 6.68882 17.9933 2.21167 12.4705 2.21167C6.94761 2.21167 2.47046 6.68882 2.47046 12.2117C2.47046 17.7345 6.94761 22.2117 12.4705 22.2117Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.4705 8.21167V12.2117"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.4705 15.2117V15.7117"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </g>,
  25,
  24,
  colors.error.main,
  null
);
